import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "hamburger",
  "use": "hamburger-usage",
  "viewBox": "0 0 40 23",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 40 23\" id=\"hamburger\">\n  <g fill=\"none\" fill-rule=\"nonzero\">\n    <g fill=\"#F4F2F1\">\n      <path d=\"M0 0h40v2.4H0zM0 10.3h40v2.4H0zM0 20.6h40V23H0z\" />\n    </g>\n    <path d=\"M-3-12h47v47H-3z\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol